import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SquirrelEnvironmentDto } from 'shared';
import { DatabaseMigrationService } from 'shared';
import { NotificationService } from 'shared';
import { TranslateService } from 'shared';

@Component({
    selector: 'delete-squirrel-environment-dialog',
    templateUrl: './delete-squirrel-environment-dialog.component.html',
    styleUrls: ['./delete-squirrel-environment-dialog.component.scss'],
    standalone: false
})
export class DeleteSquirrelEnvironmentDialogComponent implements OnInit {

  squirrelEnvironmentForm!: UntypedFormGroup;
  sqEnvDto!: SquirrelEnvironmentDto;

  constructor(private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<DeleteSquirrelEnvironmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private databaseMigrationService: DatabaseMigrationService,
    public translate: TranslateService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.createsquirrelEnvironmentForm();
  }

  createsquirrelEnvironmentForm() {
    this.squirrelEnvironmentForm = this.fb.group({
      id: [this.data.id],
      name: [this.data.name]
    });
  }

  delete(id: string) {
    if (this.squirrelEnvironmentForm.valid) {
      this.databaseMigrationService.deleteSquirrelEnvironment(id).subscribe({
        next: (data) => {
        }
      });
      this.dialogRef.close(this.squirrelEnvironmentForm.value);
    }
  }
  cancel(){
    this.dialogRef.close();
  }

}
